import React, { useState, useEffect } from 'react';
import { DownloadCloud, X } from 'lucide-react';

const PwaPrompt: React.FC = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e: any) => {
            e.preventDefault();
            setDeferredPrompt(e);

            // Limit annoyance: You could check localStorage to only show every X days
            // but for now, we just show it if the browser fires the event
            setShow(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            setDeferredPrompt(null);
            setShow(false);
        }
    };

    if (!show || !deferredPrompt) return null;

    return (
        <div className="fixed bottom-24 md:bottom-8 right-6 z-[9990] bg-zinc-900 border border-zinc-700 p-4 rounded-lg shadow-[0_10px_30px_rgba(0,0,0,0.8)] animate-in slide-in-from-bottom-5 font-mono max-w-xs transition-all">
            <button onClick={() => setShow(false)} className="absolute top-2 right-2 text-zinc-500 hover:text-white transition-colors">
                <X className="w-4 h-4" />
            </button>
            <div className="flex items-center gap-3 mb-2 pr-6">
                <div className="bg-indigo-900/50 p-2 rounded text-indigo-400">
                    <DownloadCloud className="w-5 h-5" />
                </div>
                <h3 className="text-white font-bold text-sm tracking-wide uppercase">Instale o App</h3>
            </div>
            <p className="text-xs text-zinc-400 mb-4">Investigue de forma otimizada e rápida. Adicione o Arquivos ACME à sua tela inicial para jogar em modo nativo celular e PC.</p>
            <button onClick={handleInstallClick} className="w-full bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-bold py-3 rounded transition-colors uppercase tracking-widest shadow-lg">
                Instalar Agora
            </button>
        </div>
    );
};

export default PwaPrompt;
